import { createAction, props } from '@ngrx/store';

export const setSideMenuExpanded = createAction('[Layout] set side menu expanded', props<{ expanded: boolean }>());
